export class MrcUser {
  userAccessId: 0;
  userId: 0;
  auth0Identifier: string;
  email: string;
  groupName: string;
  reportsTo: string;
  holdingSectorNumber: string;
  bdfAmount: string;
}
